import DocumentTypes from "../config/documentTypes"
import StringHelper from "./string-helper"

const MaskHelper = {
  date: (format) => {
    let mask = null

    if (format === 'DD/MM/YYYY') {
      mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    } else if (format === 'DD-MM-YYYY') {
      mask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    } else {
      mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]
    }

    return mask
  },

  applyDocumentMask: (value, type) => {
    const numeric = StringHelper.justNumbers(value)

    switch (parseInt(type)) {
      case DocumentTypes.CPF:
        return MaskHelper.maskCPF(numeric)

      case DocumentTypes.CNPJ:
        return MaskHelper.maskCNPJ(numeric)

      default:
        return value // sem mascara
    }
  },

  maskCPF: (value) => {
    return value
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
      .slice(0, 14)
  },

  maskCNPJ: (value) => {
    return value
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5')
      .slice(0, 18)
  },

  getCPFMaskPattern: () => {
    return [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/
    ]
  },

  getCNPJMaskPattern: () => {
    return [
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '/',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/
    ]
  },

  formatBrazilianPhone: (phone) => {

    if (!phone) return '';

    // remove tudo que não for número
    const digits = phone.replace(/\D/g, '');

    // celular com DDD (11 dígitos)
    if (digits.length === 11) {
      return digits.replace(
        /(\d{2})(\d{5})(\d{4})/,
        '($1) $2-$3'
      );
    }

    // fixo com DDD (10 dígitos)
    if (digits.length === 10) {
      return digits.replace(
        /(\d{2})(\d{4})(\d{4})/,
        '($1) $2-$3'
      );
    }

    // celular sem DDD (9 dígitos)
    if (digits.length === 9) {
      return digits.replace(
        /(\d{5})(\d{4})/,
        '$1-$2'
      );
    }

    // fixo sem DDD (8 dígitos)
    if (digits.length === 8) {
      return digits.replace(
        /(\d{4})(\d{4})/,
        '$1-$2'
      );
    }

    // fallback: devolve como veio
    return phone;
  }
 
}

export default MaskHelper
